import * as React from 'react';
import Select from '@mui/material/Select';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import FormHelperText from '@mui/material/FormHelperText';

interface SelectFieldProps {
	input: {
		name?: string;
		value?: any;
		onChange?: (...args: any[]) => void;
		[key: string]: any;
	};
	meta: {
		submitError?: any;
		dirtySinceLastSubmit?: boolean;
		error?: any;
		touched?: boolean;
		[key: string]: any;
	};
	label?: React.ReactNode;
	formControlProps?: any;
	shrink?: boolean;
	variant?: any;
	[key: string]: any;
}

const FormHelperTextWrapper = ({
	input: {name, value, onChange, ...restInput},
	meta,
	label,
	formControlProps,
	shrink,
	variant,
	...rest
}: SelectFieldProps) => {
	const showError = !(!(((meta.submitError && !meta.dirtySinceLastSubmit) || meta.error) && meta.touched));

	return (
		<FormControl {...formControlProps} error={showError}>
			{label && <InputLabel shrink={shrink || !!value} htmlFor={name}>{label}</InputLabel>}
			<Select
				{...rest}
				variant={variant || 'standard'}
				name={name}
				onChange={onChange}
				inputProps={restInput}
				value={value}
				label={label}
				notched={shrink || !!value}
			/>

			{showError && ((meta.error && meta.error !== true) || (meta.submitError && meta.submitError !== true)) &&
				<FormHelperText>{meta.error || meta.submitError}</FormHelperText>
			}
		</FormControl>
	);
};

export default FormHelperTextWrapper;
